

import OkButton from "../../../../../common/Button/OKButton/OKButton";

import "./CancelTripModal.scss";

import moment from "moment";

const CompactCancelTripModal = ({
                                    modalData,
                                    proceed,
                                    close,
                                }) => {
    const {
        initiator,
        reason,
        startsAt,
        endsAt,
        status,
    } = modalData || {};

    const formatDate = (dateString) => {
        if (!dateString) return "";
        return moment(dateString).format("DD.MM.YYYY HH:mm");
    };

    const getInitiatorName = () => {
        return initiator?.fullName || "Не указано";
    };

    const getReason = () => {
        return reason?.displayName || "Не указано";
    };

    const getPeriod = () => {
        const start = formatDate(startsAt);
        const end = formatDate(endsAt);
        return `${start} — ${end}`;
    };

    return (
        <div className={"cancel-trip-modal compact"}>
            <h3 style={{ opacity: "60%" }}>
                Отменить командировку
            </h3>

            <div className={"cancel-trip-modal__body"}>
                <p style={{ marginBottom: "16px" }}>
                    Вы действительно хотите отменить командировку?
                </p>

                <div className={"cancel-trip-modal__compact-info"}>
                    <div>
                        <strong>Сотрудник:</strong> {getInitiatorName()}
                    </div>
                    <div>
                        <strong>Причина:</strong> {getReason()}
                    </div>
                    <div>
                        <strong>Период:</strong> {getPeriod()}
                    </div>
                </div>

                <div className={"cancel-trip-modal__warning compact"}>
                    После отмены командировка будет снята с согласования.
                </div>
            </div>

            <div className={"cancel-trip-modal__buttons"}>
                <OkButton
                    handler={close}
                    title={"Назад"}
                />
                <OkButton
                    handler={proceed}
                    title={"Отменить"}
                    className={"danger-btn"}
                />
            </div>
        </div>
    );
};

export default CompactCancelTripModal;
